import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../../axiosAuth";
import { FILE_UPLOAD, SCHOOL_COMMERCIALS_UPDATE } from "../apiRoutes";

export interface UpdateSchoolCommercialPayload {
  commercialId: string;
  dealCloserDate?: string;
  dealAmount?: number;
  isGstIncluded?: string;
  isPdcCollected?: boolean | string;
  salesPersonType?: string;
  dealClosedBy?: string;
  leadType?: string;
  contractYear?: number;
  paymentFromEntity?: string;
  expectedLaunchDate?: string;
  aggrementDocument?: File | string | null;
}

const uploadAgreementAndGetUuid = async (file: File) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("file_type", "aggreement_document");
  const res = await axiosAuth.post(FILE_UPLOAD, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res?.data?.data?.attachment_id as string;
};

export const useUpdateSchoolCommercialMutation = (options?: { onSuccess?: () => void }) => {
  return useMutation({
    mutationFn: async (payload: UpdateSchoolCommercialPayload) => {
      let agreementUuid: string | undefined;
      if (payload.aggrementDocument instanceof File) {
        agreementUuid = await uploadAgreementAndGetUuid(payload.aggrementDocument);
      }

      const { commercialId,schoolId, aggrementDocument, isPdcCollected, ...rest } = payload as any;

      const bodyWithNulls = {
        ...rest,
        isPdcCollected:
          typeof isPdcCollected === "string"
            ? isPdcCollected.toLowerCase() === "yes"
            : isPdcCollected,
        aggrementDocument: agreementUuid ?? (typeof aggrementDocument === "string" ? aggrementDocument : undefined),
      } as Record<string, unknown>;

      const body = Object.fromEntries(
        Object.entries(bodyWithNulls).filter(([, v]) => v !== null && v !== undefined)
      );

      const response = await axiosAuth.put(
        `${SCHOOL_COMMERCIALS_UPDATE}${commercialId}/`,
        body
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Commercial info updated successfully");
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.issues?.message || error?.response?.data?.message || "Failed to update commercial info";
      toast.error(message);
    },
  });
};


